import { PrintQueueStatusSchema } from "@redotech/redo-fulfillment-printing-common/print-queue-status";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const emptyPrintQueueMock = {
  total: 0,
  completed: 0,
  failed: [],
  inFlight: [],
  activeJob: null,
};

export const watchPrintQueue = unaryStreamRpc({
  name: "watchPrintQueue",
  input: z.object({}),
  output: PrintQueueStatusSchema,
  mock: emptyPrintQueueMock,
});
